import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { injectIntl, FormattedMessage } from "react-intl";
import messages from "../../locale/messages";
import validateStep3 from "./validateStep3";
import { connect } from "react-redux";
import IncrementButton from "../IncrementButton";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import cx from "classnames";
import Row from "react-bootstrap/lib/Row";
import FormGroup from "react-bootstrap/lib/FormGroup";
import Col from "react-bootstrap/lib/Col";

import CustomCheckbox from "../CustomCheckbox";
import InputFieldComponent from "../Common/FormField/InputFieldComponent";
import FooterButton from "./FooterButton";
import SidePanel from "./SidePanel";
import SyncCalendar from "./SyncCalendar";
import updateStep3 from "./updateStep3";
import s from "./ListPlaceStep1.css";
import bt from "../../components/commonStyle.css";
import SelectFieldComponent from "../Common/FormField/SelectFieldComponent";

class MinMaxNights extends Component {
  static propTypes = {
    initialValues: PropTypes.object,
    previousPage: PropTypes.any,
    nextPage: PropTypes.any,
    listId: PropTypes.number.isRequired,
    listingSteps: PropTypes.shape({
      step3: PropTypes.string.isRequired,
      listing: PropTypes.shape({
        isPublished: PropTypes.bool.isRequired,
      }),
    }),
  };

  static defaultProps = {
    minNightData: 0,
    maxNightData: 0,
    listingSteps: {
      step3: "inactive",
      listing: {
        isPublished: false,
      },
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      minNightRange: { min: 1, max: 30 }, // Default values
      maxNightRange: { min: 1, max: 365 }, // Default values
      isDisabled: false,
      displayMaxNight: "0",
      originalMaxNight: null,
    };
  }

  componentDidMount() {
    const { initialValues, listingFields } = this.props;

    // Set ranges from listingFields if available
    if (listingFields && listingFields.minNight && listingFields.minNight[0]) {
      const minNightSetting = listingFields.minNight[0];
      this.setState({
        minNightRange: {
          min: minNightSetting.startValue || 1,
          max: minNightSetting.endValue || 30,
        },
      });
    }

    if (listingFields && listingFields.maxNight && listingFields.maxNight[0]) {
      const maxNightSetting = listingFields.maxNight[0];
      this.setState({
        maxNightRange: {
          min: maxNightSetting.startValue || 1,
          max: maxNightSetting.endValue || 365,
        },
      });
    }

    // Initialize checkbox and display value if maxNight is 365 (long stay)
    if (
      initialValues &&
      (initialValues.maxNight === 365 || initialValues.allowLongStay)
    ) {
      this.props.change("allowLongStay", true);
      this.props.change("maxNight", 365);
      this.setState({
        displayMaxNight: "Longer than 30 days",
        originalMaxNight: initialValues.maxNight,
      });
    } else if (initialValues && initialValues.maxNight) {
      this.setState({
        displayMaxNight: initialValues.maxNight.toString(),
        originalMaxNight: initialValues.maxNight,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      listingFields,
      initialValues,
      intl: { formatMessage },
    } = nextProps;

    // Update ranges from listingFields
    if (listingFields && listingFields.minNight && listingFields.minNight[0]) {
      const minNightSetting = listingFields.minNight[0];
      this.setState({
        minNightRange: {
          min: minNightSetting.startValue || 1,
          max: minNightSetting.endValue || 30,
        },
      });
    }

    if (listingFields && listingFields.maxNight && listingFields.maxNight[0]) {
      const maxNightSetting = listingFields.maxNight[0];
      this.setState({
        maxNightRange: {
          min: maxNightSetting.startValue || 1,
          max: maxNightSetting.endValue || 365,
        },
      });
    }

    // Handle case when editing and initialValues change
    if (
      initialValues &&
      (initialValues.maxNight === 365 || initialValues.allowLongStay)
    ) {
      this.props.change("allowLongStay", true);
      this.props.change("maxNight", 365);
      this.setState({
        displayMaxNight: formatMessage(messages.allowStayLongerText),
      });
    }
  }

  handleCheckboxChange = (event, newValue) => {
    const { formatMessage } = this.props.intl;
    const { listingFields } = this.props;
    if (newValue) {
      this.props.change("maxNight", 365);
      const currentMaxNight = this.props.maxNightData;
      this.setState({
        displayMaxNight: formatMessage(messages.allowStayLongerText),
        originalMaxNight: currentMaxNight,
      });
    } else {
      let minRangeValue = 1; // Default value

      if (
        listingFields &&
        listingFields.maxNight &&
        listingFields.maxNight[0]
      ) {
        const maxNightSetting = listingFields.maxNight[0];
        minRangeValue = maxNightSetting.startValue || 1;
      }

      const safeValue =
        this.state.originalMaxNight && this.state.originalMaxNight > 0
          ? this.state.originalMaxNight
          : minRangeValue;

      this.props.change("maxNight", safeValue);
      this.setState({
        displayMaxNight: safeValue.toString(),
      });
    }
  };

  handleMaxNightChange = (e) => {
    const value = e.target.value;
    this.setState({ displayMaxNight: value });

    if (value === "") {
      this.props.change("maxNight", 1);
      this.setState({ displayMaxNight: "1" });
    } else if (!isNaN(value) && parseInt(value, 10) > 0) {
      this.props.change("maxNight", parseInt(value, 10));
    }
  };

  handleMaxNightBlur = (e) => {
    const value = e.target.value;

    if (value === "") {
      this.props.change("maxNight", 1);
      this.setState({ displayMaxNight: "1" });
    }
  };

  renderIncrementButton = (field) => <IncrementButton {...field} />;

  render() {
    const {
      handleSubmit,
      previousPage,
      nextPage,
      formPage,
      step,
      initialValues,
    } = this.props;
    const { minNightRange, maxNightRange, displayMaxNight } = this.state;
    const {
      minNightData,
      maxNightData,
      listingSteps,
      listId,
      existingList,
      allowLongStay,
    } = this.props;
    const { formatMessage } = this.props.intl;
    let isDisabled = false;

    let maxDaysNoticeValue = [
      { value: "available", label: formatMessage(messages.datesOption5) },
      { value: "3months", label: formatMessage(messages.datesOption1) },
      { value: "6months", label: formatMessage(messages.datesOption2) },
      { value: "9months", label: formatMessage(messages.datesOption3) },
      { value: "12months", label: formatMessage(messages.datesOption4) },
      { value: "unavailable", label: formatMessage(messages.datesDropDown) },
    ];

    if (maxNightData > 0 && minNightData > maxNightData) {
      isDisabled = true;
    }

    const isLongStay = allowLongStay && maxNightData === 365;
    const maxNightDisabled = isLongStay;

    let path = existingList ? "home" : "index";

    return (
      <div className={s.grid}>
        <SidePanel
          title={formatMessage(messages.stepThreeCommonHeading)}
          landingContent={formatMessage(messages.minMaxPanel)}
        />
        <form onSubmit={handleSubmit}>
          <div className={s.landingMainContent}>
            <h3 className={s.landingContentTitle}>
              <FormattedMessage {...messages.maxDaysTitle} />
            </h3>
            <FormGroup className={s.formGroup}>
              <Field
                name="maxDaysNotice"
                component={SelectFieldComponent}
                inputClass={cx(
                  s.formControlSelect,
                  s.jumboSelect,
                  s.listCommonJumboSelect,
                  "listCommonJumboSelectRTL"
                )}
                options={maxDaysNoticeValue}
              />
            </FormGroup>

            <h3 className={cx(s.landingContentTitle, s.spaceTop4)}>
              <FormattedMessage {...messages.tripLength} />
            </h3>
            <Row>
              <Col lg={6} md={12} sm={12} xs={12}>
                <FormGroup className={cx(s.formGroup, s.space4)}>
                  <label>
                    <FormattedMessage {...messages.minimumStay} />
                  </label>
                  <Field
                    name="minNight"
                    type="number"
                    className={s.formControl}
                    component={InputFieldComponent}
                    min={minNightRange.min}
                    max={minNightRange.max}
                    inputClass={cx(
                      s.formControlInput,
                      s.jumboSelect,
                      s.listCommonJumboSelect,
                      "listCommonJumboSelectRTL"
                    )}
                    parse={(value) => {
                      if (value === "" || value === undefined) return ""; // Allow empty values
                      const num = parseInt(value, 10);
                      if (isNaN(num)) return minNightRange.min;
                      if (num < minNightRange.min) return minNightRange.min;
                      return num > minNightRange.max ? minNightRange.max : num;
                    }}
                    normalize={(value, previousValue) => {
                      if (value === "0") {
                        return previousValue || minNightRange.min;
                      }
                      return value;
                    }}
                  />
                </FormGroup>

                <li className={cx(s.listContent, s.fullWidth)}>
                  <span className={s.checkBoxSection}>
                    <Field
                      name="allowLongStay"
                      type="checkbox"
                      component={({ input }) => (
                        <CustomCheckbox
                          id="allowLongStay"
                          className={"icheckbox_square-green"}
                          checked={!!input.value}
                          onChange={(event) => {
                            input.onChange(event);
                            this.handleCheckboxChange(event, event);
                          }}
                        />
                      )}
                    />
                  </span>
                  <span className={cx(s.checkBoxSection, s.checkBoxLabel)}>
                    <label
                      htmlFor="allowLongStay"
                      className={cx(s.checkboxLabel, s.noPadding, "textWhite")}
                    >
                      <FormattedMessage {...messages.allowStayLonger} />
                    </label>
                  </span>
                </li>
              </Col>

              <Col lg={6} md={12} sm={12} xs={12}>
                <FormGroup className={s.formGroup}>
                  <label>
                    <FormattedMessage {...messages.maximumNightStay} />
                  </label>

                  {maxNightDisabled ? (
                    <>
                      <Field
                        name="maxNightDisplay"
                        type="text"
                        component={InputFieldComponent}
                        className={cx(s.formControl, s.inputField)}
                        value=""
                        disabled={true}
                        inputClass={cx(
                          s.formControlInput,
                          s.jumboSelect,
                          s.listCommonJumboSelect,
                          "listCommonJumboSelectRTL"
                        )}
                        placeholder={formatMessage(messages.allowStayLonger)}
                      />
                      <Field
                        name="maxNight"
                        type="hidden"
                        component="input"
                        parse={(value) => {
                          const num = parseInt(value, 10);
                          return isNaN(num) || num < 1 ? 365 : num;
                        }}
                      />
                    </>
                  ) : (
                    <Field
                      name="maxNight"
                      type="number"
                      component={InputFieldComponent}
                      className={cx(s.formControl, s.inputField)}
                      min={maxNightRange.min}
                      max={maxNightRange.max}
                      inputClass={cx(
                        s.formControlInput,
                        s.jumboSelect,
                        s.listCommonJumboSelect,
                        "listCommonJumboSelectRTL"
                      )}
                      onChange={this.handleMaxNightChange}
                      disabled={false}
                      parse={(value, previousValue) => {
                        if (value === "" || value === undefined) return ""; // Allow empty values
                        const num = parseInt(value, 10);
                        if (isNaN(num)) return maxNightRange.min;
                        return Math.max(
                          maxNightRange.min,
                          Math.min(num, maxNightRange.max)
                        );
                      }}
                    />
                  )}
                </FormGroup>
              </Col>
            </Row>
            {listingSteps?.step3 === "completed" &&
              listingSteps.listing?.isPublished && (
                <div className={s.spaceTop4}>
                  <h3 className={cx(s.landingContentTitle)}>
                    <FormattedMessage {...messages.syncCalendars} />
                  </h3>
                  <SyncCalendar listId={listId} />
                </div>
              )}
          </div>

          <FooterButton
            nextPage={nextPage}
            previousPage={previousPage}
            nextPagePath={"calendar"}
            previousPagePath={"discount"}
            formPage={formPage}
            step={step}
            isDisabled={isDisabled}
          />
        </form>
      </div>
    );
  }
}

// Decorate with connect to read form values
const selector = formValueSelector("ListPlaceStep3");

MinMaxNights = reduxForm({
  form: "ListPlaceStep3",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateStep3,
  onSubmit: updateStep3,
})(MinMaxNights);

const mapState = (state) => {
  return {
    listingFields: state.listingFields.data,
    minNightData: selector(state, "minNight"),
    maxNightData: selector(state, "maxNight"),
    allowLongStay: selector(state, "allowLongStay"),
    listingSteps: state.location.listingSteps,
    existingList: state.location.isExistingList,
  };
};

export default injectIntl(withStyles(s, bt)(connect(mapState)(MinMaxNights)));
